<template>
<!--
  <v-card
    elevation="2"
  >
  -->
  <section>
    <v-btn
        class="mx-2 button-back"
        fab
        dark
        color="white"
        elevation="2"
        v-on:click="backHome"
    >
      <v-icon large color="#2a6ebb">
        mdi-reply
      </v-icon>
    </v-btn>
    <h1 class="header-h1">Schedule Appointment</h1>
 <!--   <p>{{ pageDescription }}</p>-->
    <v-row>
      <v-col
          md="6"
          cols="12"
          order="2"
          order-md ="1"
      >
        <meeting-details />
      </v-col>
      <v-col
          md="6"
          cols="12"
          order="1"
          order-md='2'
      >
        <lead-information />
      </v-col>
    </v-row>
  </section>

<!--  </v-card> -->
</template>

<script>
import meetingDetails from "./meetingDetails";
import leadInformation from "./leadInformation";
//import moment from "moment-timezone";
  export default {
    name: "scheduleMeeting",
    components: { meetingDetails, leadInformation },
    mounted() {
  //    this.$on('actionConfirm', this.actionConfirm());

    },
    methods: {
      actionConfirm(){
        this.$parent.$emit('startConfirm', true);
      },
      async backHome(){
        let dataRequest = {
          action: 'IndexAction',
          idAppointment: this.$store.getters.idMeeting,
        }
        const resSchedule = await this.$store.dispatch("set_backDelete", dataRequest);

        console.log('resSchedule', resSchedule);
        this.$root.$emit('home');
      }
    },
  }
</script>

<style scoped>
  .button-back{
    position: absolute;
  }
  .button-back:hover{
    background-color: #f5f5f5!important;
  }
</style>
